//////////////// Localization Begin ////////////////
export const NETWORK_CONNECTION_MESSAGE =
  "Cannot connect to server, Please try again.";
export const NETWORK_TIMEOUT_MESSAGE =
  "A network timeout has occurred, Please try again.";
export const UPLOAD_PHOTO_FAIL_MESSAGE =
  "An error has occurred. The photo was unable to upload.";
export const NOT_CONNECT_NETWORK = "NOT_CONNECT_NETWORK";

export const apiUrl = process.env.VUE_APP_APIURL;

export const destination =
  "https://www.techno-chon.ac.th/centerfile/other/register/";

export const file = {
  IDENTITY: "identity",
  HOUSE: "house",
  PAYMENT: "payment",
};

export const server = {
  TOKEN_KEY: `TechN0Chon_CenteR`,
  USERNAME: `username`,
  FULLNAME: `fullname`,
  redirectMain: "https://www.techno-chon.ac.th/center",
};
